module.exports = __webpack_public_path__ + "static/media/finpos_loader.46326106.gif";